





















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CreatePurchaseOrder extends Vue {

  @Prop() public execOrder:boolean;  // 受注一覧の一括出荷処理用
  @Prop() public orderNos:Array<Common.Order>; // 一括出荷処理用、処理対象
  @Prop() public checkedOrderItems:Array<Common.SalesOrderItem>; 
  @Prop() public parentMainList:Components.ListView;
  @Prop() public salesOrderItems:Components.GrdVoucherItem;
  @Prop() public tenantSettings:Common.TenantSettings;
  @Prop() public counterpart:Common.Counterpart;
  @Prop() public parent:any;

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 出荷指示用プロパティ
  public siWorkflowId: number = null;
  public siPic: string = '';
  public siRefNo: string = '';
  public siDeliveryAggregation: boolean = false;
  public siProcessingDivision: number = 3;
  public siDeliveryDate: Date = new Date().getCalendarDate();
  public siDeliveryInstruction: string ='';
  public siWarehouse: Common.Counterpart = null;
  public siOrderByStock: Common.StockOrder = Common.StockOrder.SKU;
  public siAdStock: boolean = true;
  public siWorkflowRequired: boolean = false;
  public siHasStockItem: boolean = false;
  public isBulk: boolean = false;

  // 一括引当処理ダイアログの表示
  public mounted(){
    if(this.execOrder == true){
      // プロパティの初期化
      this.siPic = this.$api.auth.userId;
      this.siDeliveryAggregation = false;
      this.siHasStockItem = true;
    }else{
      // ダイアログ表示前バリデーション
      if(this.checkedOrderItems.length == 0){
        this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
        return;
      }
      for(var item of this.checkedOrderItems){
        var message: string = this.validateForAllocation(item);
        if(message.length > 0){
          this.$api.modal.show('', message, true, null);
          return;
        }
      }
      // 状態が確定以外で受注残数量や引当済み数量がある明細を処理対象とする。
      if(this.checkedOrderItems.length == this.checkedOrderItems.filter(orderItem => orderItem.state == Common.OrderItemStatus.SalesOrderCompleted || (orderItem.backSalesOrderQuantity == 0 && orderItem.allocatedQuantity == 0 && orderItem.state != Common.OrderItemStatus.SalesOrderAllocating)).length){
          this.$api.modal.show('', '受注残数量のある明細、出荷処理中の明細がないため処理できません。', true, null);
          return;
      }
      var parentOrder = this.checkedOrderItems[0].order;

      // // プロパティの初期化
      // var workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
      // this.siWorkflowRequired = workflows.length > 0;
      // this.siWorkflowId = workflows.length > 0 ?  workflows[0].value : 0;
      // this.onChangeWorkflow();
      this.siPic = this.counterpart.salesPerson ? this.counterpart.salesPerson : parentOrder.pic ? parentOrder.pic : this.$api.auth.userId;
      this.siRefNo = '';
      this.siDeliveryInstruction = parentOrder.deliveryInstruction;
      var map = this.checkedOrderItems
        .filter(obj => obj.scheduledDeliveryDate != null)
        .map(obj => obj.scheduledDeliveryDate);
      this.siDeliveryDate = map.length > 0 ? map.reduce((max, value) => max = max > value ? max : value) : new Date();
      this.siWarehouse = null;
      this.siOrderByStock = Common.StockOrder.SKU;
      this.siAdStock = true;
      this.siHasStockItem =  this.checkedOrderItems.filter(obj => obj.commodity.isNoStock == false).length > 0;
      this.isBulk = false;
      this.siProcessingDivision = 3;
    }
    // 共通的なプロパティの初期化
    var workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    this.siWorkflowRequired = workflows.length > 0;
    this.siWorkflowId = workflows.length > 0 ?  workflows[0].value : 0;
    this.onChangeWorkflow();
    // ダイアログの表示
    (this.$refs.shippingInstructionDialog as Components.ListDialog).showDialog();
  }
  
  // 引当処理用バリデーション
  public validateForAllocation(orderItem: Common.SalesOrderItem):string{
    // const parent = (this.parentMainList as Components.ListView).selected as Common.SalesOrder;
    const parentOrder = this.checkedOrderItems[0].order;
    if (orderItem == null){
      return '引当可能な明細を選択して下さい。';
    }
    if(parentOrder.segment.priceCalculationMethod == Common.PricingTypes.Specific){
      return '在庫単価計算が個別法の部門では、明細毎に引当を行ってください。';
    }
    // if(orderItem.backSalesOrderQuantity == 0 && orderItem.allocatedQuantity == 0 && orderItem.state != Common.OrderItemStatus.SalesOrderAllocating){
    //   return '受注明細より受注残数量のある明細、または出荷処理中の明細を選択し、明細ごとに出荷処理をしてください。';
    // }
    return '';
  }
    public getStockOrder():Common.BindItem[]{
    var list = []; 
    if(this.tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText1, this.tenantSettings.nameReserveText1));
    if(this.tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText2, this.tenantSettings.nameReserveText2));
    if(this.tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText3, this.tenantSettings.nameReserveText3));
    if(this.tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText4, this.tenantSettings.nameReserveText4));
    if(this.tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText5, this.tenantSettings.nameReserveText5));
    if(this.tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveText6, this.tenantSettings.nameReserveText6));
    if(this.tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo1, this.tenantSettings.nameReserveMemo1));
    if(this.tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo2, this.tenantSettings.nameReserveMemo2));
    if(this.tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveMemo3, this.tenantSettings.nameReserveMemo3));
    if(this.tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList1));
    if(this.tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList2, this.tenantSettings.nameReserveList2));
    if(this.tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveList1, this.tenantSettings.nameReserveList3));
    if(this.tenantSettings.usedTypeDetailReserveDate1 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate1, this.tenantSettings.nameReserveDate1));
    if(this.tenantSettings.usedTypeDetailReserveDate2 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate2, this.tenantSettings.nameReserveDate2));
    if(this.tenantSettings.usedTypeDetailReserveDate3 == Common.UsedTypes.StockAttribute) list.push(new Common.BindItem(Common.StockOrder.DetailReserveDate3, this.tenantSettings.nameReserveDate3));
    return list;
  }
  
  // 出荷指示の実行
  public async submitShippingInstruction(items:any[], index:number) {
    (this.$refs.shippingInstructionDialog as Components.ListDialog).closeDialog();
    if(this.execOrder == false){
      return this.singleShippingInstructionsQuery(items, index);
    }
    else{
      return this.bulkShippingInstructionsQuery(items, index);
    }
  }
  // OrderShippingInstructionsQueryを実行・画面の更新
  public async callOrderShippingInstructionsQuery(items:any[], index:number, onlyAllocate:boolean = false) {
    // クエリの設定
    var query = new Common.OrderShippingInstructionsQuery();
    query.parent = this.checkedOrderItems[0].order;
    query.orderItems = this.checkedOrderItems;
    query.workflowId = this.siWorkflowId ? this.siWorkflowId : 0;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.pic = this.siPic;
    query.refNo = this.siRefNo;
    query.deliveryDate = this.siDeliveryDate.getCalendarDate();
    query.deliveryInstruction = this.siDeliveryInstruction;
    query.warehouse = this.siWarehouse;
    query.orderByStock = this.siOrderByStock;
    query.adStock = this.siAdStock;
    query.isBulkOrder = this.isBulk;
    query.processingDivision=this.siProcessingDivision;
    query.onlyAllocate = onlyAllocate;
    return this.$api.execute(query,true);
  }
  // 一括出荷処理の実行
  public async bulkShippingInstructionsQuery(items:any[], index:number) {
      this.isBulk = true;
      this.$api.startWaitCusor();
      if(this.siDeliveryAggregation==true){
        // 事前に受注日順に引当を行う
        await this.parentMainList.selectedItems.sort((a,b)=>a.orderDate.getTime()==b.orderDate.getTime()?0:a.orderDate.getTime()>b.orderDate.getTime()?1:-1).reduce(async (previous, obj, listIndex) => {
          await previous;
          if(this.orderNos.filter(orderNo=>orderNo==obj.orderNo).length>0){
            this.salesOrderItems.voucherNo = obj.orderNo;
            var orderItems = new Array();
            await this.$api.execute(this.salesOrderItems.getQuery()).then(res =>{
              (res as Common.LoadResult).result.forEach(item => {
                item.order = obj;
                orderItems.push(item);
              });
            });
            this.checkedOrderItems = orderItems;
            this.siDeliveryInstruction = orderItems[0].order.deliveryInstruction;
            await this.callOrderShippingInstructionsQuery(items,index,true).then(r =>{
            // this.parentMainList.reload();
            // 行ごとに画面を更新
            this.$api.find('Order', [obj.orderNo]).then(res2 => this.parent.onWorkflow(this.parentMainList.items.indexOf(obj),res2));
          });
          }
        }, undefined).finally(()=>{ });

        // 出荷を集約する場合、1度受注明細を全て取得し、部門・得意先・納入先ごとに分けて出荷処理を行う
        let dictionary: { [key: string]: any } = {};
        // 一覧の上から順に明細情報を取得し、dictionaryに格納する
        // await this.parentMainList.selectedItems.reduce(async (previous, obj, listIndex) => {
        // 出荷を集約しない場合、受注日順に処理する
        await this.parentMainList.selectedItems.sort((a,b)=>a.orderDate.getTime()==b.orderDate.getTime()?0:a.orderDate.getTime()>b.orderDate.getTime()?1:-1).reduce(async (previous, obj, listIndex) => {
          await previous;
          if(this.orderNos.filter(orderNo=>orderNo==obj.orderNo).length>0){
            var aggregationKey = obj.segmentId + '_' + obj.counterpartId + '_' + obj.receiverId;
            if(dictionary[aggregationKey]==null) {dictionary[aggregationKey] = new Array();}
            this.salesOrderItems.voucherNo = obj.orderNo;
            await this.$api.execute(this.salesOrderItems.getQuery()).then(res =>{
              (res as Common.LoadResult).result.forEach(item => {
                item.order = obj;
                dictionary[aggregationKey].push(item);
              });
            });
          }
        }, undefined).finally(()=>{ });
        // 部門・得意先・納入先ごとまとめた明細を出荷処理する
        for(const key in dictionary){
          this.checkedOrderItems = dictionary[key];
          this.siDeliveryInstruction = dictionary[key][0].order.deliveryInstruction;
          // 出荷処理・画面の更新を実施
          await this.callOrderShippingInstructionsQuery(items,index).then(r =>{this.parentMainList.reload();});
        }
        if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();
        this.$api.closeWaitCursor(); 
      }
      else{
        // 出荷を集約しない場合、一覧の上から順に処理する
        // await this.parentMainList.selectedItems.reduce(async (previous, obj, listIndex) => {
        // 出荷を集約しない場合、受注日順に処理する
        await this.parentMainList.selectedItems.sort((a,b)=>a.orderDate.getTime()==b.orderDate.getTime()?0:a.orderDate.getTime()>b.orderDate.getTime()?1:-1).reduce(async (previous, obj, listIndex) => {
          await previous;
          if(this.orderNos.filter(orderNo=>orderNo==obj.orderNo).length>0){
            var itemIndex = this.parentMainList.items.indexOf(obj);
            this.salesOrderItems.voucherNo = obj.orderNo;
            // 出荷処理対象のOrderItemを取得
            await this.$api.execute(this.salesOrderItems.getQuery()).then(res =>{
              this.checkedOrderItems = (res as Common.LoadResult).result;
              this.checkedOrderItems.forEach(item => item.order = obj);
              // 出荷指示を更新
              this.siDeliveryInstruction = this.checkedOrderItems[0].order.deliveryInstruction;
            }).then(async res =>{
              // 出荷処理・画面の更新を実施
              await this.callOrderShippingInstructionsQuery(items,index).then(r =>{this.$api.find('Order', [obj.orderNo])
                .then(res2 => this.parent.onWorkflow(itemIndex,res2));});
            });
          }
        }, undefined).finally(()=>{ 
          this.$api.closeWaitCursor(); 
          if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();
        });
      }
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
  }

  // 出荷処理の実行
  public async singleShippingInstructionsQuery(items:any[], index:number) {

    // 一括引当処理の実行
    return this.callOrderShippingInstructionsQuery(items,index).then(res => {
      // 画面を更新
      this.$api.find('Order', [((this.parentMainList as Components.ListView).selected as Common.SalesOrder).orderNo]).then(res2 => 
        this.parent.onWorkflow(this.parentMainList.currentId,res2));

      var deliveries = res as Common.Delivery[];
      if(deliveries.length == 0){
        this.$api.modal.show('処理結果','在庫の引当が完了しました。\r\n在庫不足のため出荷伝票は作成されませんでした。',true,null,null,'閉じる');
        return true;
      }
      else{
        //トライアル中はロードマップを更新
        if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();

        var links = deliveries.map(delivery=>new Common.ModalLink(delivery.deliveryNo,String.format('/sales/SalesDelivery?deliveryNo={0}',delivery.deliveryNo)));
        if(deliveries.length == 1){
          this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',false,()=>{
            var url = String.format('/sales/SalesDelivery?deliveryNo={0}',deliveries[0].deliveryNo);
            if (url){ this.$router.push(url);}
          },links,'伝票に移動する','閉じる');
        }else{
          this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',true,null,links,'閉じる');
        }
        return true;
      }
    }).catch(()=>{return false;}); 

  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("出荷保存");
    if(this.siWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.siWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
}
